export const truckInventoryList = {
    // dump trucks
    169: [
        //IN BED OF VEHICLE
        {title: "Sharpshooter", qty: 1},
        {title: "Diggin Bar", qty: 1},
        {title: "Air Tamper", qty: 0},
        {title: "Square Shovel", qty: 1},
        {title: "Round Shovel", qty: 1},
        {title: "Bucket", qty: 2},
        {title: "Broom", qty: 1},
        //IN CAB BEHIND SEAT
        {title: "Small Red Milwalkee Tool Bag", qty: 1},
        {title: "Drillbit Set (6 Pieces + adapter)", qty: 1},
        {title: "Concrete Drill Bit", qty: 1},
        {title: "Milwalkee Cordless Drill", qty: 1},
        {title: "Milwalkee Compact Drill", qty: 1},
        {title: "Milwalkee 12v Battery", qty: 2},
        {title: "Vector Inverter", qty: 1},
        {title: "Milwalkee Rotor Hammer", qty: 1},
        {title: "Husky Adjustable Wrench (3 EACH)", qty: 1},
        {title: "Husky Wrench Set (46 pieces)", qty: 1},
        //IN BLACK BIN UNDER VEHICLE
        {title: "25' Air hose", qty: 1},
        {title: "30lb Jackhammer", qty: 1},
        {title: "30lb Jackhammer Spade 36'", qty: 1},
        {title: "60lb Jackhammer", qty: 1},
        {title: "60lb Jackhammer Spade 24'", qty: 3},
        {title: "90lb Jackhammer", qty: 0},
        {title: "90lb Jackhammer Spade", qty: 0},
        {title: "Clay Spade (60lb)", qty: 1},
        {title: "Manhole Hook", qty: 1},
        {title: "Toe Cover (Set of 2)", qty: 1},
        {title: "Whip Checks", qty: 2},
        {title: "In-Line Oil Adapter", qty: 1},
        //All vehicles shall have
        {title: "Spare Med Gloves", qty: 1},
        {title: "Spare Lrg Gloves", qty: 1},
        {title: "Spare X-Lrg Gloves", qty: 1},
        {title: "Ear Plugs", qty: 10},
        {title: "Spare safety glasses", qty: 1},
        {title: "Wheel Chock Set", qty: 1},
        {title: "Cones", qty: 2},
        {title: "Fire Extinguisher", qty: 1},
        {title: "First Aid Kit", qty: 1},
        {title: "Eye wash", qty: 1}
    ],
    171: [
        //IN BED OF VEHICLE
        {title: "Sharpshooter", qty: 1},
        {title: "Diggin Bar", qty: 1},
        {title: "Air Tamper", qty: 1},
        {title: "Square Shovel", qty: 2},
        {title: "Round Shovel", qty: 1},
        {title: "Bucket", qty: 2},
        {title: "Broom", qty: 1},
        //IN CAB BEHIND SEAT
        {title: "Small Red Milwalkee Tool Bag", qty: 1},
        {title: "Drillbit Set (5 Pieces + adapter)", qty: 1}, //
        {title: "Concrete Drill Bit", qty: 1},
        {title: "Milwalkee Cordless Drill", qty: 1},
        {title: "Milwalkee Compact Drill", qty: 1},
        {title: "Milwalkee 12v Battery", qty: 2},
        {title: "RYOBI Inverter (3 Pieces)", qty: 1},
        {title: "Milwalkee Rotor Hammer", qty: 1},
        {title: "Husky Adjustable Wrench (3 EACH)", qty: 1},
        {title: "Husky Wrench Set (46 pieces)", qty: 1},
        //IN BLACK BIN UNDER VEHICLE
        {title: "25' Air hose", qty: 1},
        {title: "30lb Jackhammer", qty: 1},
        {
            title: "30lb Jackhammer Spade 36'", qty: 1
        },
        {title: "60lb Jackhammer", qty: 1},
        {
            title: "60lb Jackhammer Spade 24'", qty: 3
        },
        {title: "90lb Jackhammer", qty: 0},
        {title: "90lb Jackhammer Spade", qty: 0},
        {
            title: "Clay Spade (60lb)", qty: 1
        },
        {title: "Manhole Hook", qty: 1},
        {title: "Toe Cover (Set of 2)", qty: 1},
        {title: "Whip Checks", qty: 2},
        {title: "In-Line Oil Adapter", qty: 1},
        //All vehicles shall have
        {title: "Spare Med Gloves", qty: 1},
        {title: "Spare Lrg Gloves", qty: 1},
        {title: "Spare X-Lrg Gloves", qty: 1},
        {title: "Ear Plugs", qty: 10},
        {title: "Spare safety glasses", qty: 1},
        {title: "Wheel Chock Set", qty: 1},
        {title: "Cones", qty: 2},
        {title: "Fire Extinguisher", qty: 1},
        {title: "First Aid Kit", qty: 1},
        {title: "Eye wash", qty: 1},
    ],
    174: [
        //IN BED OF VEHICLE
        {title: "Sharpshooter", qty: 1},
        {title: "Diggin Bar", qty: 1},
        {title: "Air Tamper", qty: 1},
        {title: "Square Shovel", qty: 2},
        {title: "Round Shovel", qty: 1},
        {title: "Bucket", qty: 2},
        {title: "Broom", qty: 1},
        //IN CAB BEHIND SEAT
        {title: "Small Red Milwalkee Tool Bag", qty: 1},
        {title: "Drillbit Set (5 Pieces + adapter)", qty: 1},
        {title: "Concrete Drill Bit", qty: 1},
        {title: "Milwalkee Cordless Drill", qty: 1},
        {title: "Milwalkee Compact Drill", qty: 1},
        {title: "Milwalkee 12v Battery", qty: 2},
        {title: "RYOBI Inverter (3 Pieces)", qty: 1},
        {title: "Milwalkee Rotor Hammer", qty: 1},
        {title: "Husky Adjustable Wrench (3 EACH)", qty: 1},
        {title: "Husky Wrench Set (46 pieces)", qty: 1},
        //IN BLACK BIN UNDER VEHICLE
        {title: "25' Air hose", qty: 1},
        {title: "30lb Jackhammer", qty: 1},
        {
            title: "30lb Jackhammer Spade 24' & 36'", qty: 2
        },
        {title: "60lb Jackhammer", qty: 1},
        {
            title: "60lb Jackhammer Spade", qty: 2
        },
        {title: "90lb Jackhammer", qty: 0},
        {title: "90lb Jackhammer Spade", qty: 0},
        {
            title: "Clay Spade (30lb)", qty: 0
        },
        {title: "Manhole Hook", qty: 1},
        {title: "Toe Cover (Set of 2)", qty: 1},
        {title: "Whip Checks", qty: 1},
        {title: "In-Line Oil Adapter", qty: 1},
        //All vehicles shall have
        {title: "Spare Med Gloves", qty: 1},
        {title: "Spare Lrg Gloves", qty: 1},
        {title: "Spare X-Lrg Gloves", qty: 1},
        {title: "Ear Plugs", qty: 10},
        {title: "Spare safety glasses", qty: 1},
        {title: "Wheel Chock Set", qty: 1},
        {title: "Cones", qty: 2},
        {title: "Fire Extinguisher", qty: 1},
        {title: "First Aid Kit", qty: 1},
        {title: "Eye wash", qty: 1},
    ],
    175: [
        //IN BED OF VEHICLE
        {title: "Sharpshooter", qty: 1},
        {title: "Diggin Bar", qty: 1},
        {title: "Air Tamper", qty: 1},
        {title: "Square Shovel", qty: 2},
        {title: "Round Shovel", qty: 1},
        {title: "Bucket", qty: 2},
        {title: "Broom", qty: 1},
        //IN CAB BEHIND SEAT
        {title: "Small Red Milwalkee Tool Bag", qty: 1},
        {title: "Drillbit Set (5 Pieces + adapter)", qty: 1},
        {title: "Concrete Drill Bit", qty: 1},
        {title: "Milwalkee Cordless Drill", qty: 1},
        {title: "Milwalkee Compact Drill", qty: 1},
        {title: "Milwalkee 12v Battery", qty: 2},
        {title: "RYOBI Inverter (3 Pieces)", qty: 1},
        {title: "Milwalkee Rotor Hammer", qty: 1},
        {title: "Husky Adjustable Wrench (3 EACH)", qty: 1},
        {title: "Husky Wrench Set (46 pieces)", qty: 1},
        //IN BLACK BIN UNDER VEHICLE
        {title: "25' Air hose", qty: 1},
        {title: "30lb Jackhammer", qty: 1},
        {
            title: "30lb Jackhammer Spade 24'", qty: 1
        },
        {title: "60lb Jackhammer", qty: 1},
        {
            title: "60lb Jackhammer Spade", qty: 2
        },
        {title: "90lb Jackhammer", qty: 0},
        {title: "90lb Jackhammer Spade", qty: 0},
        {
            title: "Clay Spade (30lb)", qty: 1
        },
        {title: "Manhole Hook", qty: 1},
        {title: "Toe Cover (Set of 2)", qty: 1},
        {title: "Whip Checks", qty: 1},
        {title: "In-Line Oil Adapter", qty: 1},
        //All vehicles shall have
        {title: "Spare Med Gloves", qty: 1},
        {title: "Spare Lrg Gloves", qty: 1},
        {title: "Spare X-Lrg Gloves", qty: 1},
        {title: "Ear Plugs", qty: 10},
        {title: "Spare safety glasses", qty: 1},
        {title: "Wheel Chock Set", qty: 1},
        {title: "Cones", qty: 2},
        {title: "Fire Extinguisher", qty: 1},
        {title: "First Aid Kit", qty: 1},
        {title: "Eye wash", qty: 1},
    ]
};